export default "__VITE_ASSET__b029d614__"